import { Component, ChangeDetectionStrategy } from '@angular/core'

@Component({
    selector: 'app-snackbar',
    templateUrl: './snackbar.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class SnackbarComponent {}
